import React from "react";

const AAOtpPage = ({
  aaMobile,

  aaOtpDigits,
  aaOtpRefs,

  handleAaOtpChange,
  handleAaOtpKeyDown,

  aaResendTimer,
  resendAaOtp,

  aaOtpError,

  verifyAaOtp,
  closeSheet,

  aaOtpValue,
  formatMobileDisplay,

  OTP_RESEND_SECONDS,
  setAaResendTimer,
  setAaOtpDigits,
}) => {
  return (
    <>
      <h2>
        OTP sent to{" "} testd
        <b>{formatMobileDisplay(aaMobile)}</b>
      </h2>

      <div className="fw-otp">
        {aaOtpDigits.map((digit, index) => (
          <input
            key={`aa-${index}`}
            ref={(el) => {
              aaOtpRefs.current[index] = el;
            }}
            inputMode="numeric"
            maxLength={1}
            value={digit}
            placeholder="0"
            onChange={(e) =>
              handleAaOtpChange(
                index,
                e.target.value
              )
            }
            onKeyDown={(e) =>
              handleAaOtpKeyDown(
                index,
                e
              )
            }
          />
        ))}
      </div>

      <p className="fw-resend">
        Have not received your OTP?{" "}

        {aaResendTimer > 0 ? (
          <span>
            Resend in {aaResendTimer} seconds
          </span>
        ) : (
          <button
            type="button"
            onClick={() => {
              setAaResendTimer(
                OTP_RESEND_SECONDS
              );

              setAaOtpDigits([
                "",
                "",
                "",
                "",
                "",
                "",
              ]);
            }}
          >
            Resend OTP
          </button>
        )}
      </p>

      <p className="fw-legal">
        By proceeding, you accept Fundswalle Terms
        &amp; Conditions. For support, please contact
        Fundswalle.
      </p>

      {aaOtpError && (
        <p className="fw-error">
          {aaOtpError}
        </p>
      )}

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={closeSheet}
        >
          Cancel
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          onClick={verifyAaOtp}
          disabled={aaOtpValue.length !== 6}
        >
          Verify
        </button>
      </div>
    </>
  );
};

export default AAOtpPage;